import routes from "@src/routes/routes";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import cartBorder from "@assets/images/cartBorder.webp";
import type { IUserDropdown } from "@src/types/AppTypes";

const dropDownList: {
  title: string;
  route: string;
  icon: JSX.Element;
}[] = [
  {
    title: "Account",
    route: routes.account,
    icon: (
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 26.625V25.375C5 21.2329 8.35786 17.875 12.5 17.875H17.5C21.6421 17.875 25 21.2329 25 25.375V26.625"
          fill=""
        />
        <path
          d="M15 14.125C12.2386 14.125 10 11.8864 10 9.125C10 6.36357 12.2386 4.125 15 4.125C17.7614 4.125 20 6.36357 20 9.125C20 11.8864 17.7614 14.125 15 14.125Z"
          fill=""
        />
      </svg>
    ),
  },
  {
    title: "Purchased Episodes & Music",
    route: routes.purchased,
    icon: (
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9597 8.96039C19.2897 8.22039 18.2797 7.79039 16.8797 7.64039V6.88039C16.8797 5.51039 16.2997 4.19039 15.2797 3.27039C14.2497 2.33039 12.9097 1.89039 11.5197 2.02039C9.12975 2.25039 7.11975 4.56039 7.11975 7.06039V7.64039C5.71975 7.79039 4.70975 8.22039 4.03975 8.96039C3.06975 10.0404 3.09975 11.4804 3.20975 12.4804L3.90975 18.0504C4.11975 20.0004 4.90975 22.0004 9.20975 22.0004H14.7897C19.0897 22.0004 19.8797 20.0004 20.0897 18.0604L20.7897 12.4704C20.8997 11.4804 20.9297 10.0404 19.9597 8.96039ZM11.6597 3.41039C12.6597 3.32039 13.6097 3.63039 14.3497 4.30039C15.0797 4.96039 15.4897 5.90039 15.4897 6.88039V7.58039H8.50975V7.06039C8.50975 5.28039 9.97975 3.57039 11.6597 3.41039ZM11.9997 18.5804C9.90975 18.5804 8.20975 16.8804 8.20975 14.7904C8.20975 12.7004 9.90975 11.0004 11.9997 11.0004C14.0897 11.0004 15.7897 12.7004 15.7897 14.7904C15.7897 16.8804 14.0897 18.5804 11.9997 18.5804Z"
          fill=""
        />
        <path
          d="M11.4299 16.64C11.2399 16.64 11.0499 16.57 10.8999 16.42L9.90988 15.43C9.61988 15.14 9.61988 14.66 9.90988 14.37C10.1999 14.08 10.6799 14.08 10.9699 14.37L11.4499 14.85L13.0499 13.37C13.3499 13.09 13.8299 13.11 14.1099 13.41C14.3899 13.71 14.3699 14.19 14.0699 14.47L11.9399 16.44C11.7899 16.57 11.6099 16.64 11.4299 16.64Z"
          fill=""
        />
      </svg>
    ),
  },
  {
    title: "Rented Episodes",
    route: routes.rentedEpisodes,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="31"
        viewBox="0 0 28 25"
        fill=""
      >
        <path d="M12.0049 22.0027C6.48204 22.0027 2.00488 17.5256 2.00488 12.0027C2.00488 6.4799 6.48204 2.00275 12.0049 2.00275C17.5277 2.00275 22.0049 6.4799 22.0049 12.0027C22.0049 17.5256 17.5277 22.0027 12.0049 22.0027ZM12.0049 20.0027C16.4232 20.0027 20.0049 16.421 20.0049 12.0027C20.0049 7.58447 16.4232 4.00275 12.0049 4.00275C7.5866 4.00275 4.00488 7.58447 4.00488 12.0027C4.00488 16.421 7.5866 20.0027 12.0049 20.0027ZM8.50488 14.0027H14.0049C14.281 14.0027 14.5049 13.7789 14.5049 13.5027C14.5049 13.2266 14.281 13.0027 14.0049 13.0027H10.0049C8.62417 13.0027 7.50488 11.8835 7.50488 10.5027C7.50488 9.12203 8.62417 8.00275 10.0049 8.00275H11.0049V6.00275H13.0049V8.00275H15.5049V10.0027H10.0049C9.72874 10.0027 9.50488 10.2266 9.50488 10.5027C9.50488 10.7789 9.72874 11.0027 10.0049 11.0027H14.0049C15.3856 11.0027 16.5049 12.122 16.5049 13.5027C16.5049 14.8835 15.3856 16.0027 14.0049 16.0027H13.0049V18.0027H11.0049V16.0027H8.50488V14.0027Z" />
      </svg>
    ),
  },
  {
    title: "Orders",
    route: routes.orderHistory,
    icon: (
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.24999 22.4809V10.8747L4.31249 6.61465C4.24666 6.46299 4.24416 6.30174 4.30499 6.1309C4.36583 5.96007 4.47249 5.84132 4.62499 5.77465C4.77749 5.70882 4.93916 5.70549 5.10999 5.76465C5.27999 5.82299 5.39791 5.92799 5.46374 6.07965L7.60624 10.8122H22.3937L24.5362 6.0809C24.6021 5.92924 24.72 5.82299 24.89 5.76216C25.06 5.70132 25.2217 5.7059 25.375 5.7759C25.5275 5.84174 25.6342 5.96007 25.695 6.1309C25.7558 6.30174 25.7533 6.46299 25.6875 6.61465L23.75 10.8747V22.4809C23.75 23.0392 23.5533 23.5155 23.16 23.9097C22.7667 24.303 22.2904 24.4997 21.7312 24.4997H8.26874C7.71041 24.4997 7.23416 24.303 6.83999 23.9097C6.44666 23.5163 6.24999 23.0401 6.24999 22.4809ZM12.5 16.3747H17.5C17.6775 16.3747 17.8262 16.3151 17.9462 16.1959C18.0654 16.0759 18.125 15.9272 18.125 15.7497C18.125 15.5722 18.0654 15.4234 17.9462 15.3034C17.8262 15.1842 17.6775 15.1247 17.5 15.1247H12.5C12.3225 15.1247 12.1737 15.1842 12.0537 15.3034C11.9346 15.4234 11.875 15.5722 11.875 15.7497C11.875 15.9272 11.9346 16.0759 12.0537 16.1959C12.1737 16.3151 12.3225 16.3747 12.5 16.3747ZM8.26874 23.2497H21.7312C21.9554 23.2497 22.1396 23.1776 22.2837 23.0334C22.4279 22.8892 22.5 22.7051 22.5 22.4809V12.0622H7.49999V22.4809C7.49999 22.7051 7.57208 22.8892 7.71624 23.0334C7.86041 23.1776 8.04458 23.2497 8.26874 23.2497Z"
          fill=""
        />
      </svg>
    ),
  },
  {
    title: "Downloads",
    route: routes.downloads,
    icon: (
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 19.5962L10.5775 15.1725L11.4612 14.2738L14.375 17.1875V6.375H15.625V17.1875L18.5375 14.275L19.4225 15.1725L15 19.5962ZM8.26875 23.875C7.69375 23.875 7.21375 23.6825 6.82875 23.2975C6.44292 22.9117 6.25 22.4313 6.25 21.8563V18.8275H7.5V21.8563C7.5 22.0479 7.58 22.2242 7.74 22.385C7.90083 22.545 8.07708 22.625 8.26875 22.625H21.7313C21.9229 22.625 22.0992 22.545 22.26 22.385C22.42 22.2242 22.5 22.0479 22.5 21.8563V18.8275H23.75V21.8563C23.75 22.4313 23.5575 22.9113 23.1725 23.2963C22.7867 23.6821 22.3063 23.875 21.7313 23.875H8.26875Z"
          fill=""
        />
      </svg>
    ),
  },
  {
    title: "Wishlist",
    route: routes.wishlist,
    icon: (
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.8594 4.375C18.4395 4.375 16.3207 5.41562 15 7.17461C13.6793 5.41562 11.5605 4.375 9.14062 4.375C7.21433 4.37717 5.36755 5.14335 4.00545 6.50545C2.64335 7.86755 1.87717 9.71433 1.875 11.6406C1.875 19.8438 14.0379 26.4836 14.5559 26.7578C14.6924 26.8313 14.845 26.8697 15 26.8697C15.155 26.8697 15.3076 26.8313 15.4441 26.7578C15.9621 26.4836 28.125 19.8438 28.125 11.6406C28.1228 9.71433 27.3566 7.86755 25.9945 6.50545C24.6325 5.14335 22.7857 4.37717 20.8594 4.375ZM15 24.8594C12.8602 23.6125 3.75 17.9324 3.75 11.6406C3.75186 10.2115 4.3204 8.84147 5.33093 7.83093C6.34147 6.8204 7.71151 6.25186 9.14062 6.25C11.4199 6.25 13.3336 7.46406 14.1328 9.41406C14.2034 9.58601 14.3236 9.73308 14.478 9.83658C14.6324 9.94008 14.8141 9.99534 15 9.99534C15.1859 9.99534 15.3676 9.94008 15.522 9.83658C15.6764 9.73308 15.7966 9.58601 15.8672 9.41406C16.6664 7.46055 18.5801 6.25 20.8594 6.25C22.2885 6.25186 23.6585 6.8204 24.6691 7.83093C25.6796 8.84147 26.2481 10.2115 26.25 11.6406C26.25 17.923 17.1375 23.6113 15 24.8594Z"
          fill=""
        />
      </svg>
    ),
  },
  {
    title: "Bookmarks",
    route: routes.bookmark,
    icon: (
      <svg
        width="31"
        height="31"
        viewBox="0 0 26 26"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 2H19C19.5523 2 20 2.44772 20 3V22.1433C20 22.4194 19.7761 22.6434 19.5 22.6434C19.4061 22.6434 19.314 22.6168 19.2344 22.5669L12 18.0313L4.76559 22.5669C4.53163 22.7136 4.22306 22.6429 4.07637 22.4089C4.02647 22.3293 4 22.2373 4 22.1433V3C4 2.44772 4.44772 2 5 2ZM18 4H6V19.4324L12 15.6707L18 19.4324V4Z"
          fill=""
        ></path>
      </svg>
    ),
  },
  {
    title: "Addresses",
    route: routes.addresses,
    icon: (
      <svg
        width="30"
        height="31"
        viewBox="0 0 30 31"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.9615 22.5996H10.0769V23.4746H10.9615V22.5996ZM19.8077 22.5996V23.4746H20.6923V22.5996H19.8077ZM11.8462 22.5996V21.7246H10.0769V22.5996H11.8462ZM18.9231 21.7246V22.5996H20.6923V21.7246H18.9231ZM19.8077 21.7246H10.9615V23.4746H19.8077V21.7246ZM15.3846 18.2246C16.3231 18.2246 17.2231 18.5934 17.8867 19.2497C18.5503 19.9061 18.9231 20.7964 18.9231 21.7246H20.6923C20.6923 20.3322 20.1331 18.9969 19.1377 18.0123C18.1423 17.0277 16.7923 16.4746 15.3846 16.4746V18.2246ZM11.8462 21.7246C11.8462 20.7964 12.219 19.9061 12.8825 19.2497C13.5461 18.5934 14.4462 18.2246 15.3846 18.2246V16.4746C13.9769 16.4746 12.6269 17.0277 11.6315 18.0123C10.6361 18.9969 10.0769 20.3322 10.0769 21.7246H11.8462ZM15.3846 7.72461C14.4462 7.72461 13.5461 8.09336 12.8825 8.74974C12.219 9.40611 11.8462 10.2964 11.8462 11.2246H13.6154C13.6154 10.7605 13.8018 10.3154 14.1336 9.98717C14.4654 9.65898 14.9154 9.47461 15.3846 9.47461V7.72461ZM18.9231 11.2246C18.9231 10.2964 18.5503 9.40611 17.8867 8.74974C17.2231 8.09336 16.3231 7.72461 15.3846 7.72461V9.47461C15.8538 9.47461 16.3039 9.65898 16.6356 9.98717C16.9674 10.3154 17.1538 10.7605 17.1538 11.2246H18.9231ZM15.3846 14.7246C16.3231 14.7246 17.2231 14.3559 17.8867 13.6995C18.5503 13.0431 18.9231 12.1529 18.9231 11.2246H17.1538C17.1538 11.6887 16.9674 12.1339 16.6356 12.462C16.3039 12.7902 15.8538 12.9746 15.3846 12.9746V14.7246ZM15.3846 12.9746C14.9154 12.9746 14.4654 12.7902 14.1336 12.462C13.8018 12.1339 13.6154 11.6887 13.6154 11.2246H11.8462C11.8462 12.1529 12.219 13.0431 12.8825 13.6995C13.5461 14.3559 14.4462 14.7246 15.3846 14.7246V12.9746ZM7.42308 4.22461H23.3462V2.47461H7.42308V4.22461ZM24.2308 5.09961V26.0996H26V5.09961H24.2308ZM23.3462 26.9746H7.42308V28.7246H23.3462V26.9746ZM6.53846 26.0996V5.09961H4.76923V26.0996H6.53846ZM7.42308 26.9746C7.18846 26.9746 6.96346 26.8824 6.79756 26.7183C6.63166 26.5542 6.53846 26.3317 6.53846 26.0996H4.76923C4.76923 26.7958 5.04883 27.4635 5.54652 27.9558C6.04422 28.448 6.71923 28.7246 7.42308 28.7246V26.9746ZM24.2308 26.0996C24.2308 26.3317 24.1376 26.5542 23.9717 26.7183C23.8058 26.8824 23.5808 26.9746 23.3462 26.9746V28.7246C24.05 28.7246 24.725 28.448 25.2227 27.9558C25.7204 27.4635 26 26.7958 26 26.0996H24.2308ZM23.3462 4.22461C23.5808 4.22461 23.8058 4.3168 23.9717 4.48089C24.1376 4.64499 24.2308 4.86754 24.2308 5.09961H26C26 4.40342 25.7204 3.73574 25.2227 3.24345C24.725 2.75117 24.05 2.47461 23.3462 2.47461V4.22461ZM7.42308 2.47461C6.71923 2.47461 6.04422 2.75117 5.54652 3.24345C5.04883 3.73574 4.76923 4.40342 4.76923 5.09961H6.53846C6.53846 4.86754 6.63166 4.64499 6.79756 4.48089C6.96346 4.3168 7.18846 4.22461 7.42308 4.22461V2.47461ZM8.30769 9.47461H3V11.2246H8.30769V9.47461ZM8.30769 19.9746H3V21.7246H8.30769V19.9746Z"
          fill=""
        />
      </svg>
    ),
  },
  {
    title: "Payment Methods",
    route: routes.paymentmethod,
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.1201 16.1413C16.3248 16.1413 15.656 15.8701 15.1136 15.3277C14.5712 14.7853 14.3 14.1164 14.3 13.3211C14.3 12.5258 14.5712 11.857 15.1136 11.3146C15.656 10.7722 16.3248 10.501 17.1201 10.501C17.9154 10.501 18.5843 10.7722 19.1267 11.3146C19.6691 11.857 19.9403 12.5258 19.9403 13.3211C19.9403 14.1164 19.6691 14.7853 19.1267 15.3277C18.5843 15.8701 17.9154 16.1413 17.1201 16.1413ZM8.38892 20.6422C7.76191 20.6422 7.22561 20.4194 6.78002 19.9739C6.3335 19.5273 6.11024 18.991 6.11024 18.365V8.27728C6.11024 7.6512 6.3335 7.11537 6.78002 6.66979C7.22561 6.22326 7.76144 6 8.38751 6H25.8513C26.4783 6 27.0146 6.22279 27.4602 6.66838C27.9058 7.11396 28.1291 7.65026 28.13 8.27728V18.365C28.13 18.991 27.9067 19.5269 27.4602 19.9725C27.0146 20.419 26.4788 20.6422 25.8527 20.6422H8.38892ZM9.799 19.2322H24.4412C24.4412 18.6023 24.6645 18.0651 25.111 17.6204C25.5566 17.1767 26.0924 16.9549 26.7185 16.9549V9.68735C26.0887 9.68735 25.5514 9.46456 25.1068 9.01898C24.6631 8.57245 24.4412 8.03615 24.4412 7.41008H9.799C9.799 8.03991 9.57574 8.57715 9.12921 9.0218C8.68363 9.4655 8.1478 9.68735 7.52172 9.68735V16.9549C8.15156 16.9549 8.6888 17.1782 9.13344 17.6247C9.57715 18.0703 9.799 18.6061 9.799 19.2322ZM23.9534 24.8725H4.15869C3.53168 24.8725 2.99538 24.6497 2.54979 24.2041C2.10327 23.7576 1.88 23.2213 1.88 22.5952V10.1752H3.29008V22.5952C3.29008 22.8114 3.3808 23.0102 3.56223 23.1917C3.74272 23.3722 3.94154 23.4624 4.15869 23.4624H23.9534V24.8725ZM8.38892 19.2322H7.52031V7.41008H8.38892C8.15391 7.41008 7.95039 7.49562 7.77836 7.66671C7.60633 7.83874 7.52031 8.04226 7.52031 8.27728V18.365C7.52031 18.6 7.60633 18.8035 7.77836 18.9755C7.95039 19.1466 8.15391 19.2322 8.38892 19.2322Z"
          fill=""
        />
      </svg>
    ),
  },
  {
    title: "Notification Settings",
    route: routes.notificationSettings,
    icon: (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill=""
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.5687 22.1406C25.6124 21.7773 25.6124 21.4102 25.5687 21.0469L26.7172 20.15C26.8266 20.0734 26.8484 19.9531 26.7828 19.8L25.6891 17.9188C25.6234 17.7984 25.4813 17.7656 25.3609 17.7984L23.9938 18.3125C23.6875 18.1266 23.4141 17.9406 23.075 17.8094L22.8672 16.3547C22.8569 16.2899 22.8236 16.231 22.7734 16.1888C22.7231 16.1466 22.6593 16.1239 22.5938 16.125H20.4062C20.275 16.125 20.1547 16.2234 20.1328 16.3547L19.9359 17.8094C19.5859 17.9406 19.3125 18.1266 19.0062 18.3125L17.6719 17.7984C17.5297 17.7656 17.3766 17.7984 17.3109 17.9188L16.2172 19.8C16.1516 19.9531 16.1844 20.0734 16.2828 20.15L17.4422 21.0469C17.4203 21.2328 17.3984 21.4188 17.3984 21.5938C17.3984 21.7687 17.4203 21.9547 17.4422 22.1406L16.2828 23.0375C16.1844 23.1141 16.1516 23.2672 16.2172 23.3875L17.3109 25.2797C17.3766 25.4219 17.5297 25.4219 17.6719 25.4219L19.0062 24.8422C19.3125 25.0609 19.5859 25.2469 19.9359 25.3891L20.1328 26.8328C20.1547 26.9641 20.275 27.0625 20.4062 27.0625H22.5938C22.7359 27.0625 22.8453 26.9641 22.8672 26.8328L23.075 25.3891C23.4141 25.2469 23.6875 25.0609 23.9938 24.8422L25.3609 25.4219C25.4813 25.4219 25.6234 25.4219 25.6891 25.2797L26.7828 23.3875C26.8484 23.2672 26.8266 23.1141 26.7172 23.0375L25.5687 22.1406ZM21.5 23.5078C20.45 23.5078 19.5859 22.6547 19.5859 21.5938C19.5859 20.5328 20.45 19.6797 21.5 19.6797C22.55 19.6797 23.4141 20.5328 23.4141 21.5938C23.4141 22.6547 22.5609 23.5078 21.5 23.5078ZM13.9312 22.6875H4V21.5938L6.1875 19.4062V12.8438C6.1875 9.45313 8.375 6.5 11.6562 5.51563V5.1875C11.6562 3.98437 12.6406 3 13.8438 3C15.0469 3 16.0312 3.98437 16.0312 5.1875V5.51563C19.3125 6.5 21.5 9.45313 21.5 12.8438V13.9375C20.7453 13.9375 20.0016 14.0578 19.3125 14.2547V12.8438C19.3125 9.78125 16.9062 7.375 13.8438 7.375C10.7813 7.375 8.375 9.78125 8.375 12.8438V20.5H13.9312C13.8766 20.8609 13.8438 21.2219 13.8438 21.5938C13.8438 21.9656 13.8766 22.3266 13.9312 22.6875ZM14.1719 23.7812C14.3906 24.4375 14.6531 25.0609 15.0031 25.6297C14.6641 25.8375 14.2703 25.9688 13.8438 25.9688C12.6406 25.9688 11.6562 24.9844 11.6562 23.7812H14.1719Z"
          fill=""
        />
      </svg>
    ),
  },
];

const UserDropdown: React.FC<IUserDropdown> = React.memo(
  ({ isDropdownOpen, setIsDropdownOpen, setShowLogoutModal }) => {
    useEffect(() => {
      function handleClickOutside(event: MouseEvent) {
        if (!event.target) return;
        const target = event.target as HTMLElement;
        if (!target.closest(".usermenu-dropdown")) {
          setIsDropdownOpen(false);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [setIsDropdownOpen]);

    return (
      <div>
        <ul
          className={`${
            !isDropdownOpen ? "hidden" : ""
          } usermenu-dropdown top-20 max-sm:top-16 min-w-[22rem] max-sm:min-w-[300px] absolute -right-10 max-md:-right-[100px] max-sm:-right-[103px] bg-gradient-to-t from-[#184AF4] to-[#1D1159] p-5 rounded-[38px_80px_80px_70px] triangle-up before:absolute before:right-14 max-md:before:right-28 before:-top-[10px] z-[3] max-xl:hidden`}
        >
          <img
            className="absolute top-0 left-0 -z-[1] size-full"
            src={cartBorder}
            alt=""
          ></img>
          {dropDownList.map((item) => {
            return (
              <li key={item.title}>
                <Link
                  className="flex items-center gap-4 text-base fill-[#89D9EE] hover:fill-white duration-150 text-[#89D9EE] hover:text-white w-full text-start p-2"
                  to={item.route}
                  onClick={() => {
                    setIsDropdownOpen(!isDropdownOpen);
                  }}
                >
                  <span className="flex-shrink-0">{item.icon}</span>
                  <span className="text-xl break-all">{item.title}</span>
                </Link>
              </li>
            );
          })}
          <li>
            <button
              className="flex items-center gap-4 text-base fill-[#89D9EE] hover:fill-white duration-150 text-[#89D9EE] hover:text-white w-full text-start p-2"
              onClick={(e) => {
                e.preventDefault();
                setShowLogoutModal(true);
                setIsDropdownOpen(!isDropdownOpen);
              }}
              aria-label="Logout"
            >
              <svg
                width="28"
                height="27"
                viewBox="0 0 28 27"
                fill=""
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.9547 6.68516V9.24453L20.5953 7.62031V4.60156L19.775 3.78125H5.00937L4.18906 4.60156V5.39891L4.15625 5.42187V22.3039L4.74687 23.0586L12.95 25.8805L14 25.1094V23.4687H19.775L20.5953 22.6484V19.6789L18.9547 18.0383V21.8281H14V8.22734L13.4586 7.47266L7.49656 5.42187H18.9547V6.68516ZM12.3594 23.9281L5.79688 21.7297V6.60312L12.3594 8.80156V23.9281ZM23.0563 14.4125H14.9023V12.7719H22.9906L20.3656 10.1469L21.5305 8.99844L25.5828 13.0344V14.1992L21.4977 18.268L20.3492 17.1195L23.0563 14.4125Z"
                  fill=""
                />
              </svg>

              <span className="text-xl">Logout</span>
            </button>
          </li>
        </ul>
        {/* <div
          className={`${
            !isDropdownOpen ? "hidden" : ""
          } fixed top-0 left-0 size-full z-[2] max-xl:hidden`}
        ></div> */}
      </div>
    );
  }
);

export default UserDropdown;
